export const MAX_50_LENGTH = 50;
export const MAX_100_LENGTH = 100;
export const MAX_200_LENGTH = 200;
export const MAX_256_LENGTH = 256;
export const MAX_500_LENGTH = 500;
export const MAX_600_LENGTH = 600;
export const MAX_1000_LENGTH = 1000;
export const MAX_2000_LENGTH = 2000;
// export const REQUIRED_MSG='{0}不能为空';
// export const MAX_LENTGTH_MSG='{0}不能超过{1}个字符';
// export const REQUIRED_SELECT_MSG='{0}必选';
// export const NUMBER_RANGE_MSG='{0}必须在{1}和{2}之间';
// export const MIN_LENTGTH_MSG='{0}不能少于{1}个字符';
